import {
  ActionIcon,
  Button,
  Modal,
  SegmentedControl,
  Tooltip,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconAutomation } from "@tabler/icons-react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { useSessionStore } from "../../../../../stores/UserStore";
import { useEffect, useState } from "react";
import BlacklistCronsContent from "./blacklists/BlacklistCronsContent";
import UnsubCronsContent from "./unsub/UnsubCronsContent";
import PrmCronsContent from "./toPrm/PrmCronsContent";
import { getCrons } from "../../../../../api/ConfigsApi";
import RefreshCronsContent from "./refreshTargeting/RefreshCronsContent";

const CronSettings = ({
  disabled,
  isBlacklist,
  isUnsub,
  defaultFilter,
  isPrm,
  isRefreshTageting,
  beforeClick,
  ...props
}) => {
  const lang = useLanguage((s) => s.language);
  const [opened, { open, close }] = useDisclosure();
  const [loading, setLoading] = useState(true);
  const [crons, setCrons] = useState([]);

  const [tab, setTab] = useState(
    isUnsub
      ? "unsub"
      : isPrm
      ? "prm"
      : isRefreshTageting
      ? "targeting"
      : "blacklists"
  );

  useEffect(() => {
    if (loading && opened) {
      getCrons()
        .then((response) => {
          setCrons(response.data.crons_list.sort((a, b) => b.id - a.id));
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [loading, opened]);

  return (
    <>
      {isBlacklist ? (
        <Button
          variant="light"
          onClick={open}
          disabled={disabled}
          leftSection={<IconAutomation size={18} />}
        >
          {lang.contact_lists.cron.label_blacklist}
        </Button>
      ) : isUnsub ? (
        <Button
          variant="light"
          onClick={open}
          disabled={disabled}
          leftSection={<IconAutomation size={18} />}
        >
          {lang.contact_lists.cron.label_unsub}
        </Button>
      ) : isPrm ? (
        <Button
          variant="light"
          onClick={() => {
            beforeClick?.();
            open();
          }}
          disabled={disabled}
          leftSection={<IconAutomation size={18} />}
          size="md"
        >
          {lang.contact_lists.cron.label_prm}
        </Button>
      ) : isRefreshTageting ? (
        <Button
          variant="light"
          onClick={() => {
            beforeClick?.();
            open();
          }}
          disabled={disabled}
          leftSection={<IconAutomation size={18} />}
          size="md"
        >
          {lang.contact_lists.cron.label_refresh}
        </Button>
      ) : (
        <Tooltip label={"Crons"}>
          <ActionIcon
            variant="light"
            size={36}
            radius={"md"}
            onClick={open}
            disabled={disabled}
            {...props}
          >
            <IconAutomation />
          </ActionIcon>
        </Tooltip>
      )}

      <Modal
        opened={opened}
        onClose={close}
        title={"Crons"}
        size={
          useSessionStore.getState().reseller?.name === "Magileads"
            ? "85%"
            : "60%"
        }
      >
        <SegmentedControl
          data={[
            {
              label: lang.blacklists.browser_tab_title,
              value: "blacklists",
            },
            {
              label: lang.unsubscribers.browser_tab_title,
              value: "unsub",
            },
            {
              label: lang.prm.browser_tab_title,
              value: "prm",
            },
            {
              label: lang.contact_lists.refresh_targeting.label,
              value: "targeting",
            },
          ]}
          value={tab}
          onChange={setTab}
          size="md"
          mb={"lg"}
          w={"100%"}
        />
        {tab === "blacklists" ? (
          <BlacklistCronsContent
            handleClose={close}
            defaultFilter={defaultFilter}
            loading={loading}
            setLoading={setLoading}
            crons={crons}
          />
        ) : tab === "unsub" ? (
          <UnsubCronsContent
            handleClose={close}
            defaultFilter={defaultFilter}
            loading={loading}
            setLoading={setLoading}
            crons={crons}
          />
        ) : tab === "targeting" ? (
          <RefreshCronsContent
            handleClose={close}
            defaultFilter={defaultFilter}
            loading={loading}
            setLoading={setLoading}
            crons={crons}
          />
        ) : (
          <PrmCronsContent
            handleClose={close}
            defaultFilter={defaultFilter}
            loading={loading}
            setLoading={setLoading}
            crons={crons}
          />
        )}
      </Modal>
    </>
  );
};

export default CronSettings;
